import 'altcha';
import { login } from './auth-api';
import { API_BASE } from '../network/api';

const devEmail = import.meta.env.DEV ? 'admin@tactus.dev' : '';
const devPassword = import.meta.env.DEV ? 'tactus123' : '';

export function renderLogin(root: HTMLElement, onSuccess: () => void): () => void {
  root.innerHTML = `
    <div class="min-h-screen grid place-items-center px-5 py-10 bg-auth-gradient">
      <form class="w-full max-w-[420px] bg-auth-card border border-border rounded-lg p-8 shadow-lift" id="login-form" novalidate>
        <h1 class="mb-2 font-heading text-2xl text-gold tracking-wide">Welcome back</h1>
        <p class="mb-6 text-sm text-text-dim">Sign in to continue.</p>
        <div id="login-error" class="mb-3.5 px-3 py-2.5 bg-error/[0.08] border border-error/40 rounded text-error text-[13px]" hidden></div>
        <label class="block mb-3.5">
          <span class="block mb-1.5 text-[13px] text-text-dim">Email</span>
          <input type="email" name="email" autocomplete="email" required value="${devEmail}"
            class="w-full px-3 py-2.5 bg-surface text-text border border-border rounded outline-none transition-colors duration-[120ms] focus:border-gold focus:shadow-glow" />
        </label>
        <label class="block mb-3.5">
          <span class="block mb-1.5 text-[13px] text-text-dim">Password</span>
          <div class="relative">
            <input type="password" name="password" autocomplete="current-password" required value="${devPassword}"
              class="w-full px-3 py-2.5 pr-10 bg-surface text-text border border-border rounded outline-none transition-colors duration-[120ms] focus:border-gold focus:shadow-glow" />
            <button type="button" id="toggle-password" class="absolute right-2.5 top-1/2 -translate-y-1/2 bg-transparent border-0 text-text-dim cursor-pointer p-0 leading-none hover:text-text" tabindex="-1" aria-label="Show password">
              <svg id="eye-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              <svg id="eye-off-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="hidden"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
            </button>
          </div>
        </label>
        <div class="mb-3.5">
          <altcha-widget challenge="${API_BASE}/auth/altcha-challenge" auto="onload" name="altcha"></altcha-widget>
        </div>
        <button type="submit" class="inline-block w-full p-3 bg-gold text-bg font-bold border-0 rounded transition-colors duration-[120ms] hover:bg-gold-bright disabled:bg-border disabled:text-text-dim disabled:cursor-not-allowed" id="login-btn">Sign in</button>
        <p class="mt-5 text-[13px] text-text-dim text-center">
          <a href="/forgot-password">Forgot password?</a>
          &nbsp;·&nbsp;
          <a href="/register">Create account</a>
        </p>
      </form>
    </div>
  `;

  const form = root.querySelector('#login-form') as HTMLFormElement;
  const errEl = root.querySelector('#login-error') as HTMLDivElement;
  const btn = root.querySelector('#login-btn') as HTMLButtonElement;

  const pwInput = form.querySelector('input[name="password"]') as HTMLInputElement;
  const toggleBtn = root.querySelector('#toggle-password')!;
  const eyeIcon = root.querySelector('#eye-icon')!;
  const eyeOffIcon = root.querySelector('#eye-off-icon')!;
  toggleBtn.addEventListener('click', () => {
    const show = pwInput.type === 'password';
    pwInput.type = show ? 'text' : 'password';
    eyeIcon.classList.toggle('hidden', show);
    eyeOffIcon.classList.toggle('hidden', !show);
  });

  const handler = async (e: Event) => {
    e.preventDefault();
    errEl.hidden = true;
    const fd = new FormData(form);
    const altchaPayload = fd.get('altcha') as string | null;
    if (!altchaPayload) {
      errEl.textContent = 'Please wait for verification to complete.';
      errEl.hidden = false;
      return;
    }
    btn.disabled = true;
    btn.textContent = 'Signing in…';
    try {
      await login(String(fd.get('email') ?? ''), String(fd.get('password') ?? ''), altchaPayload);
      onSuccess();
    } catch (err) {
      errEl.textContent = (err as Error).message;
      errEl.hidden = false;
      btn.disabled = false;
      btn.textContent = 'Sign in';
    }
  };
  form.addEventListener('submit', handler);
  return () => form.removeEventListener('submit', handler);
}
